import { Injectable } from '@angular/core';
import { FinancialApiService } from 'src/app/revenue/shared/financial-api.service';
import { PagedResultGeneric } from 'src/app/shared';
import { PledgeSearchDto } from './dto/pledge-search.dto';
import { PledgeDto } from './dto/pledge.dto';
import { PledgeSeachResultDto } from './dto/pledge-search-result.dto';
@Injectable({
  providedIn: 'root',
})
export class PledgeService {
  public constructor(private _apiService: FinancialApiService) {}

  public searchPledges(seachParams: PledgeSearchDto): Promise<PagedResultGeneric<PledgeSeachResultDto>> {
    return this._apiService.post('/financial/v2/pledge/search', seachParams);
  }

  public getPledge(pledgeId: number) {
    return this._apiService.get(`/financial/v2/pledge/${pledgeId}`);
  }

  public createPledge(pledge: PledgeDto): Promise<number> {
    return this._apiService.post('/financial/v2/pledge', pledge);
  }

  public updatePledge(pledge: PledgeDto) {
    return this._apiService.put(`/financial/v2/pledge`, pledge);
  }

  public deletePledge(pledgeId: number) {
    return this._apiService.delete(`/financial/v2/pledge/${pledgeId}`);
  }

  public exportPledges(seachParams: PledgeSearchDto) {
    return this._apiService.post('/financial/v2/pledge/export', seachParams);
  }
}
